import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'react-bootstrap'
import { useStateValue } from '@State'
import { unarchiveCourseMember } from '../actions'
import { toast } from '@CommonComponents/toast'

export const ActionButtonUnarchive = ({ user_id }) => {
  const [currentState, dispatch] = useStateValue()

  const handleClick = async () => {
    let data = { ...currentState.filters }
    data.user_id = user_id
    data.pageNum = currentState.currentCourseMemPage
    data.archivedPageNum = currentState.currentArchivePage
    try {
      await unarchiveCourseMember(data, dispatch)
      toast.info('Member Unarchived - Successfully unarchived course member')
    } catch (err) {
      if (err.response?.status === 409) {
        toast.error(
          'This course member has another active course membership and cannot be unarchived. Please contact support@myeducator.com if you need assistance.'
        )
      } else {
        toast.error(err.response?.data?.error ?? 'There was a problem unarchiving this member.')
      }
    }
  }

  return (
    <div className="text-center">
      <Button size="xs" onClick={handleClick}>
        Unarchive
      </Button>
    </div>
  )
}

ActionButtonUnarchive.propTypes = {
  user_id: PropTypes.string,
}
